import React, { useState, useEffect } from 'react';
import { Plus, Edit, Eye, Phone } from 'lucide-react';

import ClientFormModal from './modals/clients/ClientFormModal';
import ClientDetailsModal from './modals/clients/ClientDetailsModal';
import AddClientModal from './modals/clients/AddClientModal';

import { getAuthHeaders } from '@/utils/getauthheaders';

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch clienți la montare componentă
 useEffect(() => {
  const fetchClients = async () => {
    setLoading(true);
    setError(null);

    

    

    try {
      const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/clients`, {
        method: 'GET',
        headers: {
          ...getAuthHeaders(),
        },
      });

      const data = await response.json();

      if (data.success && Array.isArray(data.clients)) {
        setClients(data.clients);
        // Save to cache
        localStorage.setItem('clients', JSON.stringify(data.clients));
      } else {
        setError('Nu am putut încărca lista de clienți');
        setClients([]);
      }
    } catch (err) {
      setError('Eroare la încărcarea clienților');
      setClients([]);
    } finally {
      setLoading(false);
    }
  };

  fetchClients();
}, []);


  // Adaugă un client nou (ignoră cui, notes, email)
  const handleAddClient = (clientData) => {
  if (!clientData) return;

  const { cui, notes, email, ...allowedData } = clientData;

  const newClient = {
    ...allowedData,
    id: Math.max(...clients.map((c) => c.id), 0) + 1,
    transports: 0,
    totalValue: 0,
    memberSince: new Date().getFullYear().toString(),
  };
  setClients((prev) => [...prev, newClient]);
  setIsAddModalOpen(false);
};

const handleEditClient = async (clientData) => {
  if (!clientData || !selectedClient?.id) return;

  try {
    // Combină datele existente cu cele noi pentru a asigura că toate câmpurile sunt prezente
    const completeClientData = {
      nume_firma: clientData.nume_firma || selectedClient.nume_firma,
      telefon: clientData.telefon || selectedClient.telefon,
      cui: clientData.cui || selectedClient.cui,
      email: clientData.email || selectedClient.email,
      notes: clientData.notes || selectedClient.notes,
      location_id: clientData.location_id || selectedClient.location_id,
    };

    console.log('Trimitere date client:', completeClientData); // Pentru debug

    const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/clients/${selectedClient.id}`, {
      method: 'PUT',
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json', // Adaugă header-ul Content-Type
      },
      body: JSON.stringify(completeClientData),
    });

    const data = await response.json();
    console.log('Răspuns server:', data); // Pentru debug

    if (data.success) {
      // Update local state cu datele complete returnate de server
      setClients((prev) =>
        prev.map((c) =>
          c.id === selectedClient.id ? { ...c, ...data.client } : c
        )
      );
      
      // Actualizează și cache-ul localStorage
      const updatedClients = clients.map((c) =>
        c.id === selectedClient.id ? { ...c, ...data.client } : c
      );
      localStorage.setItem('clients', JSON.stringify(updatedClients));
      
    } else {
      console.error('Eroare la salvare:', data.error);
      alert(`Eroare la actualizarea clientului: ${data.error}`);
    }
  } catch (err) {
    console.error('Eroare la fetch:', err);
    alert('Eroare de rețea la actualizarea clientului');
  } finally {
    setSelectedClient(null);
    setIsEditModalOpen(false);
  }
};

  // Deschide detalii client
  const handleViewClient = (client) => {
    setSelectedClient(client);
    setIsViewModalOpen(true);
  };

  if (loading) {
    return <div className="p-6 text-center">Se încarcă clienții...</div>;
  }

  if (error) {
    return <div className="p-6 text-center text-red-600">{error}</div>;
  }

  return (
    <div className="p-6">
      {/* Titlu + Buton adăugare */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Clienți</h1>
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 rounded-xl hover:from-orange-600 hover:to-red-600"
        >
          <Plus className="w-5 h-5 mr-2 inline" />
          Adaugă Client
        </button>
      </div>

      {/* Grid clienți */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {clients.map((client) => (
          <div
            key={client.id}
            className="border border-gray-200 rounded-xl p-4 shadow-sm bg-white"
          >
            <div className="flex justify-between items-center mb-3">
              <h2 className="font-bold text-lg text-gray-800">{client.nume_firma}</h2>
              <div className="flex space-x-2">
                <button
                  onClick={() => {
                    setSelectedClient(client);
                    setIsEditModalOpen(true);
                  }}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <Edit className="w-4 h-4" />
                </button>
                <button
                  onClick={() => handleViewClient(client)}
                  className="text-gray-600 hover:text-gray-800"
                >
                  <Eye className="w-4 h-4" />
                </button>
              </div>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              {/* Email eliminat */}
              <div className="flex items-center">
                <Phone className="w-4 h-4 mr-2 text-gray-400" />
                {client.telefon}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal adăugare client */}
      <AddClientModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSave={handleAddClient}
      />

      {/* Modal editare client */}
      <ClientFormModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onSave={handleEditClient}
        client={selectedClient}
      />

      {/* Modal vizualizare detalii */}
      <ClientDetailsModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        client={selectedClient}
      />
    </div>
  );
};

export default Clients;
